import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BillingPeriod, Mode} from '../billing-filter/ec-billing-filter.component';
import * as moment from 'moment-timezone';
import {MONTHS_CAPITALS, YearSummaryConsolidation} from '../../../shared/ec-economics';
import {combineLatest, Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TimeFilterType} from '../../../shared/time-filter/time-filter.component';
import {isDefined} from '../../../commons/commons';


export interface ConsolidationStatus {
    month: string;
    consolidated: boolean;
    monthIndex: number;
}

@Component({
    selector: 'app-consolidation-info-bar',
    templateUrl: './consolidation-info-bar.component.html',
    styleUrls: ['./consolidation-info-bar.component.scss']
})
export class ConsolidationInfoBarComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();
    @Input() billingPeriod: Observable<BillingPeriod>;
    @Input() timeZone: string;
    @Input() summaryResponse: Observable<YearSummaryConsolidation[]>;
    consolidationStatuses: ConsolidationStatus[] = [];

    constructor() {
    }

    ngOnInit(): void {

        combineLatest([this.billingPeriod,
            this.summaryResponse])
            .pipe(takeUntil(this.destroyed))
            .subscribe(([billingPeriod, summaryResponse]) => {
                const start = moment.tz(billingPeriod.fromTime, this.timeZone);
                const end = moment.tz(billingPeriod.toTime, this.timeZone);
                const startYear = start.year();
                const endYear = end.year();
                const startMonth = start.month();
                const endMonth = end.month();
                const endStartOfDay = end.clone().startOf('day');
                const nowStartOfDay = moment.tz().startOf('day');

                const consolidationStatus = summaryResponse.filter(v => {

                    if (startYear === endYear) {
                        if (billingPeriod.mode === Mode.SINGLE) {
                            return v.year === startYear && v.month === startMonth;
                        }
                        if (isDefined(billingPeriod.type) &&
                            ((billingPeriod.type === TimeFilterType.RANGE && !endStartOfDay.isSame(nowStartOfDay, 'day')) ||
                                billingPeriod.type === TimeFilterType.LAST_MONTH)) {
                            return v.year === startYear && v.month >= startMonth && v.month < endMonth; // endMonth is excluded
                        }
                        return v.year === startYear && v.month >= startMonth && v.month <= endMonth;
                    }
                    // overall year has the right end of the range excluded
                    return (v.year === startYear && v.month >= startMonth) || (v.year === endYear && v.month < endMonth);
                });

                this.consolidationStatuses = consolidationStatus.map(cs => {
                    return {
                        month: MONTHS_CAPITALS[cs.month],
                        consolidated: cs.consolidated,
                        monthIndex: cs.month
                    } as ConsolidationStatus;
                });
            });

    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    trackByFn(index: number, consolidationStatus: ConsolidationStatus): number {
        return consolidationStatus.monthIndex;
    }

}
